<template>
  <app-dialog :visible.sync="_visible" v-on="$listeners" v-bind="$attrs" :before-close="beforeClose">
    <div class="container" :class="[size, { 'no-footer': hideFooter }]">
      <div class="header">
        <div class="title">{{ title }}</div>
        <i class="close bg-full poi" @click="_visible = false"></i>
      </div>
      <div class="main"><slot></slot></div>
      <div class="footer" v-if="!hideFooter">
        <div class="flex">
          <slot name="footer-left"></slot>
        </div>
        <div class="flex">
          <div class="btn-cancel" @click="_visible = false">{{ cancelText }}</div>
          <div class="btn-confirm" @click="handleSave">{{ confirmText }}</div>
        </div>
        <div class="flex">
          <slot name="footer-right"></slot>
        </div>
      </div>
    </div>
  </app-dialog>
</template>

<script>
import AppDialog from '../AppDialog'

export default {
  name: 'AppDialog2',
  components: {
    AppDialog,
  },
  props: {
    size: {
      type: String,
      default: 'big',
    },
    title: String,
    confirmText: {
      type: String,
      default: '保存',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    visible: Boolean,
    hideFooter: Boolean,
    beforeClose: {
      type: Function,
      default: () => {},
    },
  },
  // 没有注册的属性将不作为普通html元素属性渲染
  inheritAttrs: false,
  computed: {
    _visible: {
      set(val) {
        this.$emit('update:visible', val)
      },
      get() {
        return this.visible
      },
    },
  },
  methods: {
    handleSave() {
      if (!this.$listeners.confirm) {
        this._visible = false
      } else {
        this.$emit('confirm')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  border-radius: 16px;
  background: #fffafb;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 70px;
  padding-bottom: 89px;
  &.no-footer {
    padding-bottom: 0;
  }
  &.big {
    width: 1200px;
  }
  &.middle {
    width: 910px;
  }
  &.small {
    width: 600px;
  }
}
.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  font-size: 20px;
  line-height: 28px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  .close {
    width: 13px;
    height: 13px;
    background-image: url(~@/assets/img/icon/close.png);
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 89px;
  padding: 0 32px;
  .btn-confirm,
  .btn-cancel {
    cursor: pointer;
    width: 112px;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }
  .btn-cancel {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: rgba(0, 0, 0, 0.65);
  }
  .btn-confirm {
    color: #fff;
    background: #000000;
    margin-left: 24px;
  }
}
.main {
  flex: 1;
  padding: 40px 32px;
  overflow: auto;
}
</style>
